<template>
    <footer>
      <section id="f01">
        <div class="fnotice">
          <h4>공지사항</h4>
          <router-link :to="{ name: 'NoticeDetail', query: { brdNo: 1 } }" >경영지원플랫폼 오픈 안내 <span>2019.04.21 </span>
          </router-link>
        </div>
      </section>
      <section id="f02">
        <div class="fcompany">
          <div class="com01">
            <p>
              <a @click="popup('service')" style="cursor: pointer" class="p_first">이용약관</a>
              <a @click="popup('privacy')" style="cursor: pointer">개인정보처리방침</a>
            </p>
            <p> 경기도 성남시 분당구 대왕판교로 670 유스페이스 2-B동 7층 (우.13494) &nbsp;&nbsp; 대표번호 1533-4810</p>
            <p class="copy">COPYRIGHT 2019 ETNERS. ALL RIGHTS RESERVED</p>
          </div>
          <div class="com02">
            <p class="ctel"> 1533-4810(내선 9102)</p>
            <p> 평일 AM 08:00 ~ PM 05:00<br>
              공휴일/주말 휴무
            </p>
          </div>
        </div>
      </section>
    </footer>

</template>

<script>


  export default {
    name      : "Footer",
    methods:{
      popup: function (fileNm) {
        window.open('http://www.etners.com/privacy/ebmp/'+fileNm+'.html','_blank')
      }
    }
  }
</script>

<style>
</style>
